import { z } from 'zod';
/**
 * Harakat jurnalining SHARTNOMASI.
 *
 * Turlar va ularning o'zbekcha yorliqlari shu yerda turadi (`unit.ts` dagi
 * qoidaning davomi): backend yozadi va tekshiradi, frontend esa partiya
 * tarixida yorliq ko'rsatadi. Ro'yxat ikki marta yozilsa, ular albatta bir
 * kun ajralib ketadi (`apps/web` `apps/api` dan import qila olmaydi).
 *
 * Jurnalning O'ZI o'zgarmas: yozuv tahrirlanmaydi va o'chirilmaydi (bazada
 * UPDATE/DELETE trigger bilan taqiqlangan), shuning uchun bu yerda faqat
 * O'QISH shakli bor — yozish sxemasi yo'q.
 */
export const MOVEMENT_TYPES = ['IN', 'OUT', 'MOVE', 'ADJUST'];
export const movementTypeSchema = z.enum(MOVEMENT_TYPES);
export const isMovementType = (value) => MOVEMENT_TYPES.includes(value);
const MOVEMENT_TYPE_LABELS = {
    IN: 'Kirim',
    OUT: 'Chiqim',
    MOVE: "Ko'chirish",
    ADJUST: 'Tuzatish',
};
export const movementTypeLabel = (type) => MOVEMENT_TYPE_LABELS[type];
/**
 * Harakat qaysi hujjat sababli sodir bo'lgani — tarixda "nega" savoliga javob.
 *
 * `MOVE` — hujjatsiz, ombor ichidagi joylashtirish ishi. U `ADJUSTMENT` ga
 * qo'shilmaydi: tuzatish qoldiqni **o'zgartiradi**, ko'chirish esa faqat
 * manzilni almashtiradi. Ikkisini bir yorliq ostiga qo'yish audit jurnalini
 * yolg'onga aylantiradi — tekshiruvchi "kim qoldiqni tuzatgan" degan savolga
 * javob izlaganda oddiy ko'chirishlarni ham sanab chiqadi.
 */
export const MOVEMENT_DOC_TYPES = ['RECEIPT', 'REQUISITION', 'ADJUSTMENT', 'MOVE'];
export const movementDocTypeSchema = z.enum(MOVEMENT_DOC_TYPES);
export const isMovementDocType = (value) => MOVEMENT_DOC_TYPES.includes(value);
const MOVEMENT_DOC_TYPE_LABELS = {
    RECEIPT: 'Kirim hujjati',
    REQUISITION: 'Talabnoma',
    ADJUSTMENT: 'Tuzatish',
    MOVE: "Ombor ichida ko'chirish",
};
export const movementDocTypeLabel = (docType) => MOVEMENT_DOC_TYPE_LABELS[docType];
/**
 * Partiya tarixining bitta yozuvi — `GET /stock/batches/:batchId/movements`.
 *
 * Katak KODI ham qo'shiladi, faqat `id` emas: tarixni odam o'qiydi va
 * `A-03-02-05` uning uchun manzil, `1428` esa hech narsa. Kod bilan birga
 * `id` ham qoladi — ro'yxatdan katakka o'tish uchun.
 */
export const batchMovementSchema = z.object({
    id: z.string(),
    type: movementTypeSchema,
    batchId: z.string(),
    qty: z.number(),
    fromCellId: z.string().nullable(),
    fromCellCode: z.string().nullable(),
    toCellId: z.string().nullable(),
    toCellCode: z.string().nullable(),
    docType: movementDocTypeSchema,
    docId: z.string().nullable(),
    /** ISO satr — JSON da sana shu ko'rinishda keladi. */
    performedAt: z.string(),
    performedBy: z.string().nullable(),
    reason: z.string().nullable(),
});
/**
 * Bir so'rovda beriladigan tarix chegarasi.
 *
 * Shartnomada turadi, chunki uni IKKI tomon biladi: server shundan ko'p
 * yozuv qaytarmaydi, mijoz esa "tarixning boshi" ekanini aytib turadi va
 * odam ro'yxat kesilganini bilmasdan qolmaydi.
 */
export const MAX_BATCH_MOVEMENTS = 200;
//# sourceMappingURL=movement.js.map